export default __webpack_public_path__ + "static/media/SystemRequirements.b44cf854.md";